import type { FaireProductEntity } from "../../entity_types/product";

export const p_f5kbe4xdnn: FaireProductEntity = {
  token: "p_f5kbe4xdnn",
  type: "product",
  name: "Winter Nights & City Lights - 500 Piece Jigsaw Puzzle",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/16e0d354179c3105c92601ea528da13f53303bc04d3379a1b40f7a6b3b211f1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee10fcced10ee5fc87fcd7ce5294278714f7f1a3628d18540dbabdc5348b22cf.jpeg",
    "https://cdn.faire.com/fastly/a6afca8eb5cd74dc21872cbb54bd435ceef1d7fb5357c9e05c185040d3b53ced.jpeg",
    "https://cdn.faire.com/fastly/b09064d230988b3346f66e2343515493c56a9be95c7f8b8518b15701ad361b65.jpeg",
    "https://cdn.faire.com/fastly/1d0fac2f97e558e7dfe58943c15778c2ec106b2c1c26c7e0a229fd45f6edd0ce.jpeg",
    "https://cdn.faire.com/fastly/f4370d3f06f4698ba2f5acb824799b1c944cb422a4f21f9ed6164888cf270d45.jpeg",
    "https://cdn.faire.com/fastly/0f69d9f4c614b15bf93c6de4a09fd0bf55abbba7b1531dcd9dccd6808abaeb3b.jpeg",
  ],
  priceDollars: 19.29,
  description:
    'Get transported to the jolliest, festive town of your favorite pop culture icons in the Pippi Post Winter Nights & City Lights jigsaw puzzle. A perfect holiday gift or activity for the whole family, you\'ll love piecing together hand-drawn illustration cameos from A Christmas Story, How the Grinch Stole Christmas, Elf, Home Alone and more! With 500 pieces, snow-topped buildings, a bright starry sky, and a beautifully decorated Christmas tree complete the merry scene that\'s perfect for adults and kids alike. \n\n500 pieces   \nAges 8+    \nEasy difficulty     \n8x8 Art print included    \nCompleted Puzzle: 18" x 24"    \nBox Size: 8" x 10" x 2"',
  tags: [],
  msrpDollars: 38.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:01.626Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
